import { jsx as r } from "react/jsx-runtime";
import { Skeleton as n } from "@chakra-ui/react";
const s = ({ children: e, isLoaded: o = !1, ...t }) => /* @__PURE__ */ r(n, { isLoaded: o, ...t, children: e });
export {
  s as Skeleton
};
